<template>
  <div class="send-code">
    <span class="content__item__code" @click="handleSendCode" :style="setBgColor" v-if="!isSend">获取验证码</span>
    <span class="content__item__time" v-else>{{codeNum}}s</span>
  </div>
</template>

<script>
import { getDeleteAccountCode } from '@/services/login';

export default {
  name: 'SendCodeNew',
  props: {
    mobile: {
      type: String,
      required: true,
    },
    closeTimer: {
      type: Boolean,
    },
    type: {
      type: Number,
      default: 4,
    },
    captcha: {
      type: Boolean,
      required: true,
    },
    globalConfig:{
      type:Object,
      default:()=>{}
    }
  },
  computed:{
    setBgColor(){
      return{
        'backgroundColor':this.globalConfig.vice,
        'color':this.globalConfig.main,

      }
    }
  },
  data() {
    return {
      smsForm: {
        mobile: '',
        mobileCode: '86',
      },
      isSend: false, // 是否正在倒计时
      codeNum: 60,
    };
  },
  methods: {
    handleSendCode() {
      if (!this.mobile) {
        this.$emit('check');
        return;
      }
      this.isSend = true;
      this.codeNum = 60;
      if (this.type === 0) {
        this.getDeleteCode();
      } else
      if (this.type === 1) {
        this.getLoginFn();
      } else {
        this.getCodeFn();
      }
    },
    async getLoginFn() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        _this.$emit('update:captcha', false);
        const param = {
          data: {
            phone_code: _this.smsForm.mobileCode,
            phone: _this.mobile,
          },
          success: (res) => {
            _this.$emit('update:captcha', false);
            if (res.errcode === 11021) {
              const param2 = {
                slideCallback: 'sendSMSCodeLogin',
                slideParams: param,
                failCallback(err) {
                  _this.$emit('update:captcha', false);
                  this.isSend = false;
                  this.$message.showMessage({ info: err });
                },
              };
              _this.$emit('update:captcha', true);
              window.TAL_UC.showSlide(param2);
            } else if (res.errcode === 0) {
              _this.$emit('update:captcha', false);
              this.$message.showMessage({ info: '验证码已发送，若3分钟内未收到，请重试或联系客服' });
              _this.sendSecond = setInterval(() => {
                if (_this.codeNum > 0) {
                  // eslint-disable-next-line no-plusplus
                  _this.codeNum--;
                } else {
                  clearInterval(_this.sendSecond);
                  this.isSend = false;
                }
              }, 1000);
            } else {
              _this.codeNum = 60;
              this.isSend = false;
              this.$message.showMessage({ info: res.errmsg });
            }
          },
          fail: (err) => {
            _this.codeNum = 60;
            this.$message.showMessage({ info: err });
          },
        };
        return window.TAL_UC.sendSMSCodeLogin(param);
      } catch ({ data }) {
        return this.$message.showMessage({ info: `${data.message}` });
      }
    },
    async getCodeFn() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        _this.$emit('update:captcha', false);
        const param = {
          data: {
            phone_code: _this.smsForm.mobileCode,
            phone: _this.mobile,
            use: _this.type,
          },
          success: (res) => {
            if (res.errcode === 11021) {
              const param2 = {
                slideCallback: 'sendSMSCodeLogin',
                slideParams: param,
                failCallback(err) {
                  _this.$emit('update:captcha', false);
                  this.isSend = false;
                  this.$message.showMessage({ info: err });
                },
              };
              _this.$emit('update:captcha', true);
              window.TAL_UC.showSlide(param2);
            } else if (res.errcode === 0 || res.errcode === 11524) {
              _this.$emit('update:captcha', false);
              this.$message.showMessage({ info: '验证码已发送，若3分钟内未收到，请重试或联系客服' });
              _this.sendSecond = setInterval(() => {
                if (_this.codeNum > 0) {
                  // eslint-disable-next-line no-plusplus
                  _this.codeNum--;
                } else {
                  clearInterval(_this.sendSecond);
                  this.isSend = false;
                }
              }, 1000);
            } else {
              _this.codeNum = 60;
              this.isSend = false;
              _this.$emit('update:captcha', false);
              this.$message.showMessage({ info: res.errmsg });
            }
          },
          fail: (err) => {
            _this.codeNum = 60;
            this.$message.showMessage({ info: err });
          },
        };
        window.TAL_UC.sendSMSCode(param);
      } catch ({ data }) {
        this.$message.showMessage({ info: `${data.message}` });
      }
    },
    async getDeleteCode() {
      getDeleteAccountCode({
        phone: this.mobile,
      }).finally(() => {
        this.captcha = false;
        this.$message.showMessage({ info: '验证码已发送，若3分钟内未收到，请重试或联系客服' });
        this.sendSecond = setInterval(() => {
          if (this.codeNum > 0) {
            // eslint-disable-next-line no-plusplus
            this.codeNum--;
          } else {
            clearInterval(this.sendSecond);
            this.isSend = false;
          }
        }, 1000);
      });
    },
  },
  watch: {
    closeTimer(val) {
      this.isSend = val;
    },
    smsForm: {
      deep: true,
      handler(val) {
        this.$emit('sendMobile', val.mobile);
      },
    },

  },

};

</script>
<style lang='less' scoped>
  .send-code {
    display: inline-block;
    &__content {
      position: relative;
      display: inline-block;
      height: 32px;
      text-align: center;
      z-index: 1;
      .lab {
        display: inline-block;
        width: 100px;
        text-align: right;
        font-size:19px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(9,2,3,1);
      }
      input {
        padding: 0 20px;
        width:264px;
        height:31px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(190,190,190,1);
        border-radius:6px;
      }
    }
    .tip {
      position: absolute;
      left: 105px;
      bottom: -27px;
      display: block;
      font-size:13px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(202,77,28,1);
    }
  }
  .content__item {
    &__tip {
      position: absolute;
      left: 15px;
      bottom: -27px;
      display: block;
      font-size:13px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(202,77,28,1);
    }
    &__code {
      display:inline-block;
      width:132px;
      height:40px;
      background:rgba(104,149,60,1);
      border-radius:20px;
      right: 32px;
      top: 0px;
      line-height: 40px;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      // border:2px solid rgba(80,123,54,1);
      text-align: center;
      &:hover {
        cursor: pointer;
      }
    }
    &__time {
      display:inline-block;
      width:132px;
      height:40px;
      line-height: 40px;
      text-align: center;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:500;
      color:#fff;
      border-radius: 280px;
      background:rgba(210,210,210,1);
      &:hover {
        cursor: pointer;
      }
    }
    &__select {
      margin-left: 16px;
      margin-bottom: 5px;
      width: 368px;
      background:rgba(255,255,255,1);
    }
    &__submit {
      margin: 0 auto;
      width:144px;
      height:40px;
      line-height: 34px;
      color: #fff;
      text-align: center;
      background:rgba(250,194,0,1);
      border:3px solid rgba(238, 160, 42, 1);
      border-radius:20px;
      &:hover {
        cursor: pointer;
      }
      &:active {
        color: #8B613C;
      }
    }
  }
  input:-webkit-autofill {
    -webkit-box-shadow:0 0 0 100px rgba(238,220,187,1)inset;
    -webkit-text-fill-color: rgba(185,163,123,1);
  }
  input:-webkit-autofill:focus {
    -webkit-box-shadow:0 0 0 100px rgba(238,220,187,1) inset;
    -webkit-text-fill-color: rgba(185,163,123,1);
  }
  input::-webkit-input-placeholder{
    color: #B9A37B;
  }
  input[type='checkbox']{
    width: 16px;
    height: 16px;
    background-color: #fff;
    border: 1px solid #c9c9c9;
    border-radius: 3px;
    outline: none;
  }

</style>
